import { Check, CircleDot, CopyCheck } from 'lucide-react'
import {
  isAttemptedStatus,
  type UserProgressStatus,
} from '@/lib/progress-status'
import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip'

/**
 * Status glyph for problem rows. A duplicate-propagated solve renders the
 * same green at the same size but with a stacked-copy check, and the
 * hover/focus tooltip explains where the solve actually happened.
 */
export function ProgressStatusIcon({
  status,
  viaTitle,
}: {
  status: UserProgressStatus | null | undefined
  /** Title of the problem that earned the status, when resolvable. */
  viaTitle?: string | null
}) {
  if (status === 'solved') {
    return <Check className="h-4 w-4 text-green-500" />
  }
  if (status === 'solved_equivalent') {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          {/* role="img" + aria-label give screen readers the status; the
              richer "solved via" detail is a mouse-hover enhancement. The
              icon is informational, so it stays out of the tab order. */}
          <span
            role="img"
            aria-label="Solved via an equivalent problem"
            className="inline-flex"
          >
            <CopyCheck
              aria-hidden="true"
              className="h-4 w-4 text-green-500/80"
            />
          </span>
        </TooltipTrigger>
        <TooltipContent>
          {viaTitle
            ? `Solved as “${viaTitle}” — same question, different source`
            : 'Solved via an equivalent problem from another source'}
        </TooltipContent>
      </Tooltip>
    )
  }
  if (isAttemptedStatus(status)) {
    return <CircleDot className="h-4 w-4 text-yellow-500" />
  }
  return null
}
